import React, { useState, useEffect, useRef } from 'react';
import { motion, useScroll, useTransform, useInView } from 'framer-motion';
import Lenis from '@studio-freight/lenis';
import './App.css';

const LOGO_URL = "original_color_logo_cropped.png";
const ICON_HANGER = "hanger 1.png";
const ICON_HANGER_TWO = "hanger 2.png";
const ICON_MANNEQUIN = "mannequin.png";
const ICON_MEASURE = "tape measure.png";
const ICON_CAMERA = "camera 1.png";
const ICON_CAMERA_TWO = "camera 2.png";
const ICON_WARDROBE = "wardrobe 1.png";
const ICON_WARDROBE_TWO = "wardrobe 2.png";

const GOOGLE_SCRIPT = "https://script.google.com/macros/s/AKfycbwlxz-HYQ2VWLcjqYjgRVbIv7C3AUBp3RODunKacBQUoHsrZNd2pSnq9JMGXHsz-iSIwg/exec"

function SmoothScroll({ children }) {
useEffect(() => {
  const lenis = new Lenis({
    duration: 1.2,
    easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
    smoothWheel: true,
  });

  // prevent "restore scroll position" weirdness
  lenis.scrollTo(0, { immediate: true });

  let rafId;
  function raf(time) {
    lenis.raf(time);
    rafId = requestAnimationFrame(raf);
  }
  rafId = requestAnimationFrame(raf);

  return () => {
    cancelAnimationFrame(rafId);
    lenis.destroy();
  };
}, []);
  return <>{children}</>;
}

function RollingIconRow({ icons, startSide = "left" }) {
  const containerRef = useRef(null);

  const [mounted, setMounted] = useState(false);
  useEffect(() => setMounted(true), []);

  const { scrollYProgress } = useScroll({
    target: containerRef,
    offset: ["start 0.9", "end start"],
  });

  const xValue =
    startSide === "left" ? ["0vw", "0vw", "120vw"] : ["0vw", "0vw", "-120vw"];

  // dead-zone so it stays perfectly still at start
  const x = useTransform(scrollYProgress, [0, 0.12, 1], xValue);
  const rotate = useTransform(scrollYProgress, [0, 0.12, 1], [0, 0, 720]);
  const opacity = useTransform(scrollYProgress, [0.8, 1], [1, 0]);

  return (
    <div ref={containerRef} className="seam-divider">
      <motion.div
        className="icon-row-inner"
        style={{
          justifyContent: startSide === "left" ? "flex-start" : "flex-end",

          ...(mounted ? { x, opacity } : { x: 0, opacity: 1 }),
        }}
      >
        {icons.map((item, i) => (
          <motion.img
            key={i}
            src={item.icon}
            alt=""
            className="icon-image"
            style={mounted ? { rotate } : { rotate: 0 }}
          />
        ))}
      </motion.div>
    </div>
  );
}



export default function HeyTwinLanding() {
  const [formData, setFormData] = useState({ name: '', email: '' });
  const [formData2, setFormData2] = useState({ name: '', email: '' });
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = async (formNumber) => {
    const data = formNumber === 1 ? formData : formData2;
    
    if (data.name && data.email) {
      // 1. Immediately show success to the user (since we can't read the response)
      setSubmitted(true);
      
      // 2. Send the data in the background
      fetch(GOOGLE_SCRIPT, {
        method: 'POST',
        mode: 'no-cors', 
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      }).catch(err => console.error("Script Error:", err));

      // 3. Reset forms
      setFormData({ name: '', email: '' });
      setFormData2({ name: '', email: '' });
      setTimeout(() => setSubmitted(false), 3000);
    }
  };

  const handleChange = (e, formNumber) => {
    const { name, value } = e.target;
    if (formNumber === 1) {
      setFormData(prev => ({ ...prev, [name]: value }));
    } else {
      setFormData2(prev => ({ ...prev, [name]: value }));
    }
  };

  const iconCircles_one = [
    { icon: ICON_HANGER },
    { icon: ICON_MEASURE },
    { icon: ICON_WARDROBE_TWO },
    { icon: ICON_CAMERA_TWO },
    { icon: ICON_HANGER_TWO }
  ];

  const iconCircles_two = [
    { icon: ICON_HANGER },
    { icon: ICON_MEASURE },
    { icon: ICON_WARDROBE_TWO },
    { icon: ICON_CAMERA_TWO },
  ];

  const iconCircles_three = [
    { icon: ICON_MEASURE }, 
    { icon: ICON_HANGER },
    { icon: ICON_WARDROBE },
    { icon: ICON_MANNEQUIN },
    { icon: ICON_CAMERA },
    { icon: ICON_WARDROBE_TWO },
  ];

  return (
    <SmoothScroll>
      <div className="landing-container">
        <style>{`
          @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@400;700;900&display=swap');
          @font-face {
            font-family: 'Frankfurter';
            src: url('/Franxurter-w11D9.ttf') format('truetype');
          }
        `}</style>

        <div className="hero-section">
          <div className="logo-container">
            <img src={LOGO_URL} alt="heyTwin Logo" className="logo" />
          </div>
          <h1 className="main-heading">Shop with confidence,<br />knowing the fit is right</h1>
          <p className="subheading">Let heyTwin bring you on an exciting journey through the whole new world of online clothes fitting</p>
          <p className="signup-text">Sign up for your early access invite and<br />Explore More Below to see what you can expect!</p>
          <div className="form-container">
            <input type="text" name="name" placeholder="Name:" value={formData.name} onChange={(e) => handleChange(e, 1)} className="form-input" />
            <input type="email" name="email" placeholder="Email:" value={formData.email} onChange={(e) => handleChange(e, 1)} className="form-input" />
            <button onClick={() => handleSubmit(1)} className="form-button">Notify Me!</button>
          </div>
          {submitted && <p className="success-message">Thanks for signing up! We'll be in touch soon.</p>}
        </div>

        <RollingIconRow icons={iconCircles_one} startSide="left" />

        <div className="features-section">
          <div className="features-container">
            <h2 className="features-heading">Some features you can expect...</h2>
            <div className="feature-item">
              <div className="feature-plus"><span className="plus-sign">+</span></div>
              <div className="feature-content">
                <h3 className="feature-title">Personalized Digital Avatar & Virtual Try-On</h3>
                <p className="feature-text">With a digital avatar customized based on your own unique body measurements, visualize how clothes will fit your body based on your measurements, not generic models.</p>
              </div>
            </div>
            <div className="feature-item">
              <div className="feature-plus"><span className="plus-sign">+</span></div>
              <div className="feature-content">
                <h3 className="feature-title">Outfit Recommender</h3>
                <p className="feature-text">With heyTwin, you will never have to worry on what to wear. We will recommend outfits for you based on the style and colour tones that you want and will make sure it is suitable for the weather!</p>
              </div>
            </div>
          </div>
        </div>

        <RollingIconRow icons={iconCircles_two} startSide="right" />

        <div className="cta-section">
          <div className="cta-container">
            <h2 className="cta-heading">What are you waiting for?</h2>
            <p className="cta-text">Sign up now and have priority<br />access to our platform!</p>
            <div className="cta-form">
              <input type="text" name="name" placeholder="Name:" value={formData2.name} onChange={(e) => handleChange(e, 2)} className="cta-input" />
              <input type="email" name="email" placeholder="Email:" value={formData2.email} onChange={(e) => handleChange(e, 2)} className="cta-input" />
              <button onClick={() => handleSubmit(2)} className="cta-button">Notify Me!</button>
            </div>
            {submitted && <p className="success-message">Thanks for signing up! We'll be in touch soon.</p>}
          </div>
          <div className="bottom-icon-row">
            {[...iconCircles_three, ...iconCircles_three].map((item, i) => (
              <img key={i} src={item.icon} alt="" className="icon-image" />
            ))}
          </div>
        </div>
      </div>
    </SmoothScroll>
  );
}